module.exports = __webpack_public_path__ + "img/icons-map-pointer.8370383c.png";